
import { toast } from "react-toastify";
import Constants from "../../constants/Constants";
import axios from "../axios";
// import { checkToken } from "../utils/Utils";
import authHeader from "./auth-header";
import RequestService from "./RequestService";
let SavingsService = {
    fetchOneSaving: async (id) => {
        let url = Constants.SAVINGS.ONE;
        try {
            let req = await axios.get(`${url}/${id}`, {
                headers: {
                    Authorization: `Bearer ${authHeader()}`
                }
            });
            if (req.data) {
                let { type, data } = req.data;
                console.log(type)
            }
            return req.data;
        }
        catch (e) {
            console.log(e);
            toast.error("There seems to be a network connection issue");
        }
    },
    fetchAllSavings: async () => {
        //let url = Constants.SAVINGS.ONE;
        try {
            let url = Constants.SAVINGS.ALL;
            let req = await RequestService(url, false, {}, true);
            console.log(req);
            return req;
        }
        catch (e) {
            console.log(e);
            toast.error("There seems to be a network connection issue");
        }
    },
    create : async (data) => {
        let url = Constants.SAVINGS.NEW;
        let req = await RequestService(url, true, data, true);
        console.log(req);
        return req;
    },
    bank : {
        initiate : async (data) => {
            let url = Constants.SAVINGS.BANK.INITIATE;
            let req = await RequestService(url, true, data, true);
            console.log(req);
            return req;
        }
    },
    
    card : {
        initiate : async (data) => {
            let url = Constants.SAVINGS.CARD.INITIATE;
            let req = await RequestService(url, true, data, true);
            console.log(req);
            return req;
        }
    },
    stash : {
        initiate : async (data) => {
            let url = Constants.SAVINGS.STASH.INITIATE;
            let req = await RequestService(url, true, data, true);
            console.log(req);
            return req;
        }
    },
    topupSavings : async (data) => {
        let url = Constants.SAVINGS.STASH.TOPUP;
        let req = await RequestService(url, true, data, true);
        console.log(req);
        return req;
    }
}

export default SavingsService